/**
 * @prettier
 * @flow
 */
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import securitycode from 'payment-icons/min/outline/security-code.svg';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { theme } from 'src/AppRoot';
import { translate } from 'src/utils/translate/translate';

export function FormCvvField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();
    // const { errors, control, formState: { isSubmitting }, watch } = useFormContext();

    // const v = watch(name);

    const minLength = 3;
    const maxLength = 4;

    return (
        <Controller
            as={TextField}
            name={`${name}.cvv`}
            label={label}
            placeholder={translate('CVV')}
            // helperText={errors[name]?.message ?? helperText}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('CVV is required'),
                },
                minLength: {
                    value: minLength,
                    message: translate('CVV must be at least @number characters', { number: minLength }),
                },
                maxLength: {
                    value: maxLength,
                    message: translate('CVV must be at most @number characters', { number: maxLength }),
                },
            }}
            error={!!errors[name]?.['cvv']}
            value={value}
            onChange={onChange}
            InputProps={{
                inputComponent: NumberFormatCustom,
                ...InputProps,
                endAdornment: (
                    <InputAdornment position='end'>
                        <img src={securitycode} alt='' height={theme.spacing(2.5)} style={{ opacity: 0.7 }} />
                    </InputAdornment>
                ),
            }}
            inputProps={{ autoComplete: 'cc-csc' }}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
            classes={{ root: classes.input }}
        />
    );
}

export function NumberFormatCustom(props: { inputRef: any, name: string, onChange: Function }) {
    const { inputRef, onChange, ...other } = props;

    return <NumberFormat {...other} getInputRef={inputRef} onValueChange={values => onChange(values.value)} isNumericString format='####' decimalScale={0} />;
}

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderTopColor: 'white',
                borderLeftColor: 'white',
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                borderBottomLeftRadius: 0,
            },
            '&:hover fieldset': {
                // borderTopColor: 'white',
            },
            '&.Mui-focused fieldset': {
                // borderTopColor: 'white',
            },
        },
    },
}));

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
    |},
    InputProps?: any,
    defaultValue?: string,
|};
